<template>
  <v-container fluid class="pa-8 fill-height">
    <v-row no-gutters class="fill-height">
      <v-col
        cols="12"
        md="5"
        lg="4"
        class="preview-column d-flex align-center justify-center"
      >
        <div class="mobile-frame elevation-24">
          <div class="mobile-screen">
            <assistant-chat-viewer v-model="localconfig" />
          </div>
          <div class="mobile-home-bar"></div>
        </div>
      </v-col>
      <v-col cols="12" md="7" lg="8" class="settings-column pa-6">
        <div class="d-flex align-start justify-space-between mb-6">
          <div class="d-flex flex-column">
            <h2 class="text-h5 font-weight-bold">تنظیمات دستیار هوشمند</h2>
            <v-divider></v-divider>
            <v-card-actions class="pa-4 bg-grey lighten-5">
              <v-icon color="orange" small class="mx-2"
                >mdi-information-outline</v-icon
              >
              <span class="grey--text text--darken-2">
                این تنظیمات مربوط به ظاهر دستیار در حالت «استفاده با لینک» است.
                اگر قصد دارید از آن در کارت ویزیت، معرفی محصول پرو استفاده کنید،
                لطفاً از داخل بخش ویرایش یا ساخت کیو آرتان اقدام نمایید. است.
              </span>
            </v-card-actions>
          </div>
          <v-btn
            class="btn-download rounded-lg"
            elevation="2"
            @click="goBack()"
          >
            بازگشت
            <v-icon left>mdi-arrow-left</v-icon>
          </v-btn>
        </div>

        <v-card flat class="rounded-xl border pa-4">
          <ai-chat-settings v-model="localconfig" />
        </v-card>
        <div
          class="d-flex justify-end mt-28 mb-0 position-relative left-0 bottom-0"
        >
          <v-btn class="btn-get-code rounded-lg" @click="saveDesign">
            <v-icon right class="ml-2">mdi-content-save</v-icon>
            ذخیره دیزاین
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AiChatSettings from "./aiChatSettings.vue";
import AssistantChatViewer from "./assistantChatViewer.vue";

export default {
  components: {
    AiChatSettings,
    AssistantChatViewer,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
      //unique_key
    },
    assistantId: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,

      aiChatConfig: {
        assistantName: "",
        assistantId: null,
        assistant: null,
        hasAssistants: false,
        hasAssistantsName: false,
        hasAssistantsFamily: false,
        hasAssistantsMobile: false,
        chatSettings: {
          headerColor: "#667eea",
          headerColor2: "#764ba2",
          headerGradient: true,
          backGradient: true,
          backColor: "#ffffff",
          backColor2: "#E91515f",
          backgroundImage: null,
          useImageBackground: false,
          textColor: "#333333",
          fontSize: 14,
          chatLogo: null,
          floatingIcon: "mdi-robot",
          useImageLogo: false,
        },
      },
    };
  },
  created() {
    if (!this.assistantId && !!localStorage.getItem("assisid")) {
      this.localassistantId = localStorage.getItem("assisid");
    }
  },
  mounted() {
    this.fetchDesign();
    console.log("Mounted with designData:", this.designData);
    if (!this.assistantId) {
      if (!!localStorage.getItem("assisid")) {
        this.localassistantId = localStorage.getItem("assisid");
      } else {
        this.$toast?.warning(
          "شناسه دستیار ارائه نشده است، ممکن است تنظیمات ذخیره نشود مجدد از لیست دستیاران وارد ویرایش دیزاین شوید",
        );
        console.warn("No assistantId provided via props or localStorage");
      }
    }
    console.log(this.id, this.assistantId, "check prop");
  },
  computed: {
    localassistantId: {
      get() {
        return this.assistantId || localStorage.getItem("assisid") || null;
      },
      set(newVal) {
        this.$emit("update:assistantId", newVal);
      },
    },
    previewConfig() {
      return {
        assistantId: this.localassistantId,
        design: this.aiChatConfig,
      };
    },
    localconfig: {
      get() {
        return this.aiChatConfig;
      },
      set(newVal) {
        this.aiChatConfig = { ...newVal };
      },
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async fetchDesign() {
      this.loading = true;
      try {
        const { data } = await this.$api.get(
          `${this.$aiApi}/assistant/design/${this.id}`,
        );

        if (
          data?.design &&
          typeof data.design === "object" &&
          Object.keys(data.design).length > 0
        ) {
          this.aiChatConfig.assistantId = this.assistantId;
          this.aiChatConfig.assistant = data.assistant;

          this.localconfig = {
            ...this.aiChatConfig,
            ...data.design,
          };
          console.log("Design loaded:", this.localconfig);
        } else {
          await this.autoSaveDefaults();
        }
      } catch (err) {
        console.error("Fetch error:", err);
        this.$toast?.error("خطا در بارگذاری طراحی");
      } finally {
        this.loading = false;
      }
    },

    async autoSaveDefaults() {
      try {
        const payload = {
          assistantId: this.assistantId,
          design: { ...this.localconfig },
        };
        await this.$api.post(`${this.$aiApi}/assistant/design`, payload);
        console.log("Defaults auto-saved");
        this.$toast?.info("تنظیمات پایه ذخیره شد");
      } catch (err) {
        console.error("Auto-save failed:", err);
      }
    },

    async saveDesign() {
      this.loading = true;
      try {
        const payload = {
          assistantId: this.assistantId,
          design: { ...this.localconfig },
        };

        await this.$api.post(`${this.$aiApi}/assistant/design`, payload);
        this.$toast?.success("دیزاین با موفقیت ذخیره شد");
        this.$router.push({ name: "assistantAi" });
      } catch (err) {
        console.error("Save error:", err?.response?.data || err);
        this.$toast?.error(
          "خطا در ذخیره" +
            (err?.response?.data?.message
              ? ` → ${err.response.data.message}`
              : ""),
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.settings-column {
  background-color: #f8f9fa;
  min-height: 100vh;
  height: auto;
  padding-bottom: 80px !important;
}

.preview-column {
  background-color: #e9ecef38;
  height: 100vh;
  position: sticky;
  top: 0;
}

.mobile-frame {
  width: 320px;
  height: 640px;
  background: #1a1a1a;
  border-radius: 40px;
  padding: 12px;
  position: relative;
  border: 4px solid #333;
}

.mobile-screen {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 30px;
  overflow: hidden;
  position: relative;
}

.mobile-home-bar {
  width: 100px;
  height: 4px;
  background: #333;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

:deep(.floating-chat-button) {
  bottom: 10px !important;
  right: 10px !important;
}

:deep(.chat-panel) {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
}
</style>
